import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-81a15b76"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-guojihua"
}, null, -1));
import { useI18n } from "vue-i18n";
import { ElMessage } from "element-plus";
import { useStore } from "@/store/index";
export default {
  __name: 'index',
  setup(__props) {
    const store = useStore();
    const {
      locale,
      t
    } = useI18n();
    const handleSetLanguage = lang => {
      locale.value = lang;
      store.setLanguage(lang);
      ElMessage.success({
        message: t("language.switch")
      });
    };
    return (_ctx, _cache) => {
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      return _openBlock(), _createBlock(_component_el_dropdown, {
        trigger: "click",
        class: "international",
        onCommand: handleSetLanguage,
        teleported: false
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            disabled: _unref(store).language === 'zh',
            command: "zh"
          }, {
            default: _withCtx(() => [_createTextVNode(" 中文 ")]),
            _: 1
          }, 8, ["disabled"]), _createVNode(_component_el_dropdown_item, {
            disabled: _unref(store).language === 'en',
            command: "en"
          }, {
            default: _withCtx(() => [_createTextVNode(" English ")]),
            _: 1
          }, 8, ["disabled"])]),
          _: 1
        })]),
        default: _withCtx(() => [_hoisted_1]),
        _: 1
      });
    };
  }
};